VjsAdmin.IpWhitelistAdd = (function () {
    function init() {
        const events = new Events();
        events.changePlatform();
    }

    let Events = VjsUtility.Controller.extend({
        btn: null,
        events: {
            'click .add-ip': 'addIP',
            'change #platform_id': 'changePlatform',
            'change #district_id': 'changeDistrict',
        },
        addIP() {
            this.startLoadingButton();

            const params = {};
            params.ip = $.trim($('#ip').val());
            params.district_id = $.trim($('#district_id').val());
            params.license_id = $.trim($('#license_id').val());
            params.role_id = $.trim($('#role_id').val());
            params.platform_id = $.trim($('#platform_id').val());

            if (params.ip === '') {
                this.stopLoadingButton();
                return VjsUtility.Notification.error({
                    text: '`IP` is required',
                    time: 4000,
                });
            }
            if (+params.platform_id !== 0 && params.district_id === '') {
                this.stopLoadingButton();
                return VjsUtility.Notification.error({
                    text: '`District` is required',
                    time: 4000,
                });
            }

            const req = new VjsUtility.Request();
            req.post('/api/ip-whitelist/', params)
                .done(() => {
                    window.location.href = '/admin/ip-whitelist/';
                })
                .fail(() => {
                    this.stopLoadingButton();
                    VjsUtility.Notification.error({
                        text: 'Error - look in console',
                        time: 4000,
                    });
                });
        },
        changeDistrict() {
            const params = {};
            params.district_joint_guid = $('#district_id option:selected').attr('district-joint-guid');

            $('#license_id').html('');
            const req = new VjsUtility.Request();
            req.post('/api/licenses/', params)
                .done((res) => {
                    $(res.data).each((i, d) => {
                        $('#license_id').append(`<option value="${d.license_id}">${d.license_name}</option>`);
                    });
                })
                .fail(() => {
                    this.stopLoadingButton();
                    VjsUtility.Notification.error({
                        text: 'Error - look in console',
                        time: 4000,
                    });
                });
        },
        changePlatform() {
            const platformId = +$('#platform_id').val();
            if (platformId === 0) {
                $('.form-group.districtId').hide();
                $('.form-group.licenseId').hide();
            } else {
                $('.form-group.districtId').show();
                $('.form-group.licenseId').show();
            }
        },
        startLoadingButton() {
            this.btn = $('.add-ip');
            this.btn.text('Adding...');
            this.btn.prop('disabled', true);
        },
        stopLoadingButton() {
            this.btn.text('Add IP');
            this.btn.prop('disabled', false);
        },
    });

    return {
        init,
    };
}());
